import { useEffect } from "react";
import { extendSessionOnActivity } from "../services/tokenRefreshService";

/** While a working surface stays open, ping sooner than typical idle (15–30 min). */
export const SESSION_KEEP_ALIVE_MS = 4 * 60 * 1000;

/**
 * Keep the backend lastActiveAt fresh while `enabled` (call form, search, live call).
 * Does not replace click/key listeners — it covers long dwell with no extra keystrokes.
 */
export function useSessionKeepAlive(enabled: boolean): void {
  useEffect(() => {
    if (!enabled) return;
    void extendSessionOnActivity({ force: true });
    const id = window.setInterval(() => {
      void extendSessionOnActivity({ force: true });
    }, SESSION_KEEP_ALIVE_MS);
    return () => window.clearInterval(id);
  }, [enabled]);
}
